import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-question-vars",
  "use": "foquz-icon-question-vars-usage",
  "viewBox": "0 0 21 20",
  "content": "<symbol viewBox=\"0 0 21 20\" fill=\"none\" id=\"foquz-icon-question-vars\"><path d=\"M9 3h12M9 10h12M9 17h12M5 3a2 2 0 11-4 0 2 2 0 014 0zm0 7a2 2 0 11-4 0 2 2 0 014 0zm0 7a2 2 0 11-4 0 2 2 0 014 0z\" stroke=\"currentColor\" stroke-width=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol